module.exports = __webpack_public_path__ + "static/media/lt.fc57a52e.svg";